import React, { useEffect, useRef, useState } from "react";
import Button from "../modules/Button";
import ModalComponent from "../modules/Modal";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { addAllIncomeInfo } from "../IncomeDetails/redux/actions";
import {
  addAllPersonalInfo,
  addPersonalInfo,
  isModified,
} from "../PersonalInfo/redux/actions";
import { addAllEduInfo } from "../Education/redux/actions";
import { useNavigate } from "react-router-dom";

import { doLogout } from "../LoginPage/redux/actions";
import { addStatusInfo, addStatusList } from "../WelcomeBack/redux/actions";
import TransitionAlerts from "../modules/Alerts";
import GradientLoader from "../modules/Loader";
function BtnSet(props) {
  const navigate = useNavigate();

  const myRef = useRef(null);
  const dispatch = useDispatch();
  const [Link, setLink] = useState("");
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const panList = useSelector((state) => state.income.panList);

  const education = useSelector((state) => state.education.eduInfo);
  const status = useSelector((state) => state.status.statusData);
  const [percentage, setPercentage] = useState(0);
  const [Err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [allTotal, setAllTotal] = useState({
    personal: "",
    edu: "",
    income: "",
    total: "",
  });
  const [incomeList, setIncomeList] = useState({
    Father: "fatherIncomeCertificate",
    Mother: "motherIncomeCertificate",
    Sibling1: "sibling1IncomeCertificate",
    Sibling2: "sibling2IncomeCertificate",
    Sibling3: "sibling3IncomeCertificate",
    Guardian: "guardianIncomeCertificate",
    Myself: "incomeCertificate",
    "No-one": "noIncomeCertificate",
  });

  const [ModalData, setModalData] = useState({
    show: false,
    type: "cancel",
    title: "Cancel application?",
    countDown: " ",
    desc: "If you cancel, all your information will be lost. This CANNOT be undone. Do you still want to cancel?",
  });
  const getValidDate = (date) => {
    if (date?.split("-")[2]?.length > 2) {
      date = date?.split("-")?.reverse()?.join("-");
    } else if (!date?.split("-")[1]) {
      date = `${date}-01-01`;
    }
    return date;
  };
  const submitPan = async (name, dob, value) => {
    // const name = props.item?.firstName;
    // const dob = getValidDate(props.item?.dob);
    let type = false;

    try {
      let panInfo = { panNumber: value, name: name, dob: dob };
      if (Link.split("/")[3] === "income") {
        let res = await await api.verifyPan(panInfo, tokenData.token);
        // let pL = { ...panList };
        if (res?.data?.panStatusCode === "E") {
          // setTimeout(()=>)
            // return true;
            type = true;
          }
          return type;
        } else {
        console.log('call fro verify done')
        return true;
      }
    } catch (error) {
      console.error("Error Validating PAN:", error);
    }
  };
  const getPersonal = (personal) => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    for (let i in personal) {
      if (i === "address") {
        let address = personal[i].filter(
          (a) => a.addressType === "TEMPORARY"
        )[0];
        // console.log("in temporary", address);
        for (let j in address) {
          if (
            // address[j] &&
            j !== "addressType" &&
            j !== "salesForceAddressId" &&
            j !== "id"
          ) {
            let perm = personalInfo.address.filter(
              (a) => a.addressType === "PERMANENT"
            )[0];

            if (address?.pin === "" || address?.pin !== perm?.pin) {
              total += 1;
              totalList = [...totalList, j];
              if (j === "addressProof") {
                // if (address?.pin !== perm?.pin) {
                // total += 1;
                // totalList=[...totalList,j]

                if (docs && docs[`currentAddressProof`]?.name) {
                  count += 1;
                  countList = [...countList, j];
                }
                // }
              } else if (address[j]) {
                count += 1;
                countList = [...countList, j];
              }
            }

            // total += 1;
            // totalList = [...totalList, j];
          }
        }
      } else if (
        i === "BirthCertificate" ||
        i === "dob" ||
        i === "email" ||
        i === "experience" ||
        i === "firstName" ||
        i === "gender" ||
        i === "mobile" ||
        i === "photo"
      ) {
        if (i === "mobile") {
          if (personal[i]?.length === 10) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];
        } else if (i === "email") {
          const pinRegex =
            /^([a-zA-Z0-9._-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,4})$/;
          // isError = !pinRegex.test(personal[i]);
          if (pinRegex.test(personal[i]?.trim())) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];
        } else if (i === "photo") {
          // isError = !pinRegex.test(personal[i]);
          if (docs && docs?.profilePicture) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];
        } else if (i === "BirthCertificate") {
          // isError = !pinRegex.test(personal[i]);
          if (docs && docs?.BirthCertificate?.name) {
            count += 1;
            countList = [...countList, i];
          }

          total += 1;
          totalList = [...totalList, i];
        } else {
          if (personal[i]) {
            count += 1;
            countList = [...countList, i];
          }
          total += 1;
          totalList = [...totalList, i];

          // console.log("personal i", i);
        }
        // else {
        // total += 1;
        // totalList = [...totalList, i];

        // }
      }
    }
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };
    let finalpercentage = Math.floor(Math.abs(count / total) * 100);
    setAllTotal({ ...allTotal, personal: finalpercentage });
    dispatch(
      addStatusInfo(["personal", Math.floor(Math.abs(count / total) * 100)])
    );
    dispatch(addStatusList(["personalList", detailsList]));
  };
  const getIncome = (income) => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    let list = income["membersList"];

    for (let i in list) {
      if (list[i]?.relationShipType !== "No-one") {
        for (let j in list[i]) {
          if (
            j === "dob" ||
            j === "doc" ||
            j === "firstName" ||
            j === "income" ||
            j === "mobile" ||
            j === "occupation" ||
            j === "pan"
          ) {
            if (j === "mobile" || j === "pan") {
              if (j === "mobile" && list[i][j]?.length === 10) {
                count += 1;
                countList = [...countList, j];
              } else if (
                j === "pan" &&
                list[i][j]?.length === 10 &&
                submitPan(list[i]["firstName"], list[i]["dob"], list[i]["pan"])
                // panList[list[i]?.relationShipType]
              ) {
                count += 1;
                countList = [...countList, j];
              }
            } else if (j === "doc") {
              if (docs && docs[incomeList[list[i]?.relationShipType]]) {
                count += 1;
                countList = [...countList, j];
              }
            } else if (list[i][j]) {
              count += 1;
              countList = [...countList, j];
            }
            total += 1;
            totalList = [...totalList, j];
          }
        }
      } else if (list[i]?.relationShipType === "No-one") {
        total = 1;
        if (docs && docs[incomeList[list[i]?.relationShipType]]) {
          count += 1;
        }
      }
    }
    let totalDivide;
    if (count === 0 && total === 0) {
      totalDivide = 0;
    } else if (count === 0) {
      totalDivide = 0;
    } else {
      totalDivide = count / total;
    }
    let finalpercentage = Math.floor(Math.abs(totalDivide * 100).toFixed(2));

    console.log(
      "income percentage",
      finalpercentage,
      count,
      total,
      totalList,
      countList
    );
    setAllTotal({ ...allTotal, income: finalpercentage });
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };
    dispatch(
      addStatusInfo(["income", Math.floor(Math.abs(totalDivide * 100))])
    );
    dispatch(addStatusList(["incomeList", detailsList]));
  };

  const getEdu = (edu) => {
    let count = 0;
    let total = 0;
    let list = edu;
    let totalList = [];
    let countList = [];

    // if (edu["campusSpecific"] === "Others") {
    //   total = 6;
    // } else {
    //   total = 5;
    // }
    for (let i in list) {
      if (
        i === "admissionLetter" ||
        i === "campusSpecific" ||
        // i === "campus" ||
        i === "city" ||
        i === "fee" ||
        i === "paymentReciept" ||
        i === "paymentReceipt"
      ) {
        total += 1;
        totalList = [...totalList, i];
        if (
          i === "admissionLetter" ||
          i === "paymentReciept" ||
          i === "paymentReceipt"
        ) {
          if (i === "paymentReciept" || i === "paymentReceipt") {
            if (docs?.paymentReceipt || docs?.paymentReciept) {
              count += 1;
              countList = [...countList, i];
            }
          } else if (docs && docs[i]) {
            count += 1;
            countList = [...countList, i];
          }
          // } else if (
          //   i === "campus" &&
          //   list["campusSpecific"] === "Others" &&
          //   list["campus"]
          // ) {
          //   count += 1;
        } else if (list[i]) {
          count += 1;
          countList = [...countList, i];
        }
      }
      // if (i === "campusSpecific" && list[i] === "Others") {
      //   total += 1;
      //   if (list["campus"]) {
      //     count += 1;
      //     countList=[...countList,i]

      //   }
      // }
    }
    let finalpercentage = Math.floor(Math.abs(count / total) * 100).toFixed(2);

    setAllTotal({ ...allTotal, edu: finalpercentage });
    let remElements = [];
    totalList.forEach((number) => {
      if (!countList.includes(number)) {
        remElements = [...remElements, number];
      }
    });
    let detailsList = { count: countList, total: totalList, rest: remElements };

    dispatch(
      addStatusInfo(["education", Math.floor(Math.abs(count / total) * 100)])
    );
    dispatch(addStatusList(["eduList", detailsList]));
  };
  const getPercentage = () => {
    // if (Link.split("/")[2] === "status" || Link.split("/")[3] === "income") {
    //   getIncome(incomeInfo);
    // }
    // getPersonal(personalInfo);
    // getEdu(education);

    let total = status.personal + status.education + status.income;
    console.log("total", total);
    if (total > 0) {
      total = Math.floor(total / 3);
      console.log("total is not 0", total);
    }
    if (total % 1 === 0) {
      setPercentage(total);
    } else {
      setPercentage(0);
    }
    // let total = Math.floor(Object.values(status).reduce((a, b) => a + b) / 3);
    // setPercentage(total);
  };
  const CancelData = () => {
    if (ModalData.type === "confirm") {
      setModalData({
        ...ModalData,
        show: false,
        type: "cancel",
        title: "Cancel application?",
        desc: "If you cancel, all your information will be lost. This CANNOT be undone. Do you still want to cancel?",
      });
    } else {
      setModalData({
        show: true,
        title: "Cancelling your application in..",
        countDown: 5,
        type: "countdown",
        desc: "",
      });
    }
  };
  const cancelSession = () => {
    if (Link.split("/")[2] === "review") {
      setModalData({ ...ModalData, type: "cancel", show: true });
    } else {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url + "/application/status");
      navigate("/application/status");
    }
  };
  const countStop = () => {
    clearTimeout(myRef.focus);
    setModalData({
      show: false,
      title: "Cancel application?",
      countDown: "",
      type: "",
      desc: "If you cancel, all your information will be lost. This CANNOT be undone. Do you still want to cancel?",
    });
  };
  const CombineData = (type) => {
    let data = { userId: idInfo.userId };
    let personalInfo2 = {
      ...personalInfo,
      currentAddressProof: "",
      BirthCertificate: "",
      photo: null,
      disability: [],
      personDisability: `[${personalInfo.disability}]`,
      orphan: personalInfo.orphan || "No",
    };
    let eduInfo2 = {
      ...education,
      // admissionLetter: "",
      // paymentReciept: "",
      // year: "2024-2026",
    };
    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    let noMemeber = false;
    let memberArray = [
      "mother",
      "father",
      "sibling1",
      "sibling2",
      "sibling3",
      "guardian",
      "myself",
    ];
    for (let i = 0; i < incomeInfo2.membersList.length; i++) {
      if (
        memberArray.includes(
          incomeInfo2.membersList[i]["relationShipType"].toLowerCase()
        )
      ) {
        noMemeber = true;
        break;
      }
    }
    // let isNone=incomeInfo2.membersList.filter((a) => a["relationShipType"].toLowerCase().includes('mother'|| 'father'|| 'sibling1'||'sibling2'||"guardian"||'myself'))
    incomeInfo2 = { ...incomeInfo2, earningMember: noMemeber };
    data = {
      ...data,
      application: { id: idInfo.appId, applicationStatus: type },
    };
    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        eduInfo: {
          ...eduInfo2,
          year: ["B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)
            ? "2024-2028"
            : "2024-2026",
        },
      },
      registration: { ...tokenData.registrationData },
      salesForceUserId: tokenData.salesForceUserId,
    };
    return data;
  };
  const destructureData = (data) => {
    if (data?.user) {
      data = data.user;
    }
    dispatch(addTokenInfo(["userId", data?.userId]));
    dispatch(addTokenInfo(["appId", data?.application?.id]));
    dispatch(addTokenInfo(["personalId", data?.application?.personalInfo?.id]));
    dispatch(addTokenInfo(["registrationData", data?.registration]));
    dispatch(addTokenInfo(["applicationData", data?.application]));
    dispatch(addTokenInfo(["salesforceUserId", data?.salesforceUserId]));
    dispatch(
      addTokenInfo(["applicationStatus", data?.application?.applicationStatus])
    );
    if (data?.application?.incomeInfo) {
      dispatch(addAllIncomeInfo(data?.application?.incomeInfo));
    }
    dispatch(addAllEduInfo(data?.application?.eduInfo));

    let personalInfo = data?.application?.personalInfo;
    personalInfo["BirthCertificate"] = ""
    dispatch(addAllPersonalInfo(personalInfo));
    let disList = [];
    if (data?.application?.personalInfo?.personDisability) {
      const disabilities = data.application.personalInfo.personDisability;
      // disList = disabilities.replace(/^\[|\]$/g, "").split(",");
      disList = disabilities
        .split(",")
        // .map(item => item.trim()) // Remove whitespace around elements
        .filter((item) => item && item !== "[" && item !== "]" && item !== "");
      disList = disList?.map((item) => item.replace(/^\[|\]$/g, ""));
    }
    if (disList.length === 0 || disList.includes(null)) {
      disList = [];
    }
    dispatch(addPersonalInfo({ type: "disability", value: disList }));

    /*    let url = GetBaseUrl(window.location.href);
    if (data.user.application.applicationStatus === "Submitted") {
      navigate("/application/submitted-status");
    } else {
      navigate("/application");
    }*/
  };
  const submitData = async (type) => {
    try {
      let users;
      if (type === "Submitted") {
        users = await api.updateSalesforce(CombineData(type), tokenData.token);
      } else {
        users = await api.update(CombineData(type), tokenData.token);
      }
      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };

  const confirmModal = async () => {
    // if (
    //   Link.split("/")[2] === "status" ||
    //   Link.split("/")[2] === "review" ||
    //   Link.split("/")[3] === "income"
    // ) {
    getPercentage();
    // }
    let url = GetBaseUrl(window.location.href);
    console.log("Link clicked", Link, window.location.href);
    if (Link.split("/")[2] === "review") {
      // setLink(url);
      let total = (status.personal + status.education + status.income) / 3;
      setAllTotal({ ...allTotal, total: total });
      if (total !== 100) {
        setModalData({
          show: true,
          title: "Kindly Fill all the Mandatory before submission",
          countDown: "",
          type: "confirm",
          desc: "Please ensure that you have filled the mandatory fields. The application cannot be submitted without submitting the mandatory fields and documents.",
        });
      } else {
        setModalData({
          show: true,
          title: "Confirm before you submit",
          countDown: "",
          type: "confirm",
          desc: "Please ensure that you have carefully gone through all your details. No change is possible once the application is submitted.",
        });
      }

      // submitData();
    } else if (
      !Link.split("/")[3] ||
      Link.split("/")[3] === "personal-details"
    ) {
      configureData("Registered");
      // if (status.personal == 100) {
      console.log("in personal");
      navigate("/application/form/income");
      // window.location.replace(url + "/application/form/income");
      // } else {
      //   alert("Please fill all the mandatory fields");
      // }
    } else if (Link.split("/")[3] === "income") {
      // if (status.income == 100) {
      console.log("in income");
      configureData("Registered");

      // let url = window.location.href;
      navigate("/application/form/education");
      // window.location.replace(url + "/application/form/education");
    } else if (Link.split("/")[3] === "education") {
      configureData("Registered");

      // if (percentage == 100) {
      dispatch(addTokenInfo(["personalData", personalInfo]));
      dispatch(addTokenInfo(["incomeData", incomeInfo]));
      dispatch(addTokenInfo(["eduData", education]));

      // window.location.replace(url + "/application/review");
      navigate("/application/review");

      // } else {
      //   alert("Please fill all the mandatory fields");
      // }
      // setLink(url);
      // setModalData({
      //   show: true,
      //   title: "Confirm before you submit",
      //   countDown: "",
      //   type: "confirm",
      //   desc: "Please ensure that you have carefully gone through all your details. No change is possible once the application is submitted.",
      // });
    }
  };
  const appSubmit = async (type) => {
    setLoading(true);

    try {
      const users = await submitData(type);
      setLoading(false);
      return users;
    } catch (err) {
      setLoading(false);

      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };
  const configureData = async (type) => {
    setLoading(true);

    try {
      let users = await appSubmit(type);
      if (users?.statusCode == 200) {
        setLoading(false);

        destructureData(users.data);
        console.log("destructureData done");
      }
      return users;
    } catch (err) {
      console.log("err", err);
    }
  };
  const nextPage = async () => {
    if (ModalData.type === "confirm") {
      let users = await configureData("Submitted");
      if (users?.statusCode == 200) {
        setLoading(false);

        if (
          users?.data?.application?.applicationData?.applicationStatus ===
            "Submitted" ||
          users?.data?.application?.applicationData?.applicationStatus ===
            "Awarded" ||
          users?.data?.application?.applicationData?.applicationStatus ===
            "Waitlisted" ||
          users?.data?.application?.applicationStatus === "Submitted" ||
          users?.data?.application?.applicationStatus === "Awarded" ||
          users?.data?.application?.applicationStatus === "Waitlisted"
        ) {
          // if (users.data.application.applicationStatus === "Submitted" ) {
          let url = GetBaseUrl(window.location.href);
          // window.location.replace(url + "/application/submission");
          navigate("/application/submission");

          setModalData({ ...ModalData, show: false });
        } else if (users.data.application.applicationStatus === "Registered") {
          // const scrollToTop = () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          // };
          setAlertType({
            msg: "Application was not submitted successfully, Please try again later",
            type: "otp",
          });
          setAlert(true);
          setTimeout(() => setAlert(false), 3000);
        } else {
          let url = GetBaseUrl(window.location.href);
          // window.location.replace(url + "/application/submission");
          navigate("/application/submission");
        }
      } else {
        setLoading(false);
        alert("Sorry! Something went wrong. Kindly Submit again.");
      }
    } else {
      setModalData({ ...ModalData, show: false });
    }
  };
  useEffect(() => {
    if (ModalData.countDown > 0) {
      myRef.focus = setTimeout(
        () =>
          setModalData({ ...ModalData, countDown: ModalData.countDown - 1 }),
        1000
      );
    } else if (ModalData.countDown === 0) {
      // dispatch(doLogout());
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url + "/application/status");
      navigate("/application/status");

      //   setModalData({ ...ModalData, countDown: '' })
    }
  }, [ModalData]);
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, []);
  useEffect(() => {
    getPercentage();
  }, [personalInfo, education, incomeInfo, docs]);

  useEffect(() => {
    getPersonal(personalInfo);
  }, [personalInfo, docs]);

  useEffect(() => {
    getIncome(incomeInfo);
  }, [incomeInfo, docs]);

  useEffect(() => {
    getEdu(education);
  }, [education, docs]);

  useEffect(() => {
    for (let i in props.errList) {
      if (props.errList[i] === true) {
        setErr(true);
      }
    }
    // console.log('err',props.errList)
  }, [props?.errList]);
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, [window.location.href]);
  return (
    <div className="btn-set">
      <Button
        disabled={Err}
        onClickHandler={() => cancelSession()}
        type={"contained override"}
        value={"Cancel"}
      />
      {/* <div className="ack-text">Saved 5 seconds ago</div> */}
      <Button
        type={"contained"}
        disabled={
          Link.split("/")[2] === "review" &&
          (!props.boxes?.box1 || !props.boxes?.box2)
            ? true
            : (!Link.split("/")[3] ||
                Link.split("/")[3] === "personal-details") &&
              status.personal !== 100
            ? true
            : Link.split("/")[3] === "income" && status.income !== 100
            ? true
            : Link.split("/")[3] === "education" && status.education !== 100
            ? true
            : false
        }
        value={
          props.isSubmit || Link.split("/")[2] === "review" ? "Submit" : "Next"
        }
        // disabled={Link.split("/")[2] === "review" && percentage !== 100}
        onClickHandler={() => confirmModal()}
      />
      {/* </div> */}
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show && !loading}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          countDown={ModalData.countDown}
        >
          {ModalData.countDown > 0 ? (
            <div className="modal-btn-set countdown">
              <Button
                onClickHandler={() => countStop()}
                type={"contained "}
                value={"Stop"}
              />
            </div>
          ) : (status.personal + status.education + status.income) / 3 !==
            100 ? (
            <div className="modal-btn-set countdown">
              <Button
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    show: false,
                  })
                }
                type={"contained "}
                value={"Ok"}
              />
            </div>
          ) : (
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => CancelData()}
                type={"contained override"}
                value={
                  ModalData.type === "confirm" ? "Review Again" : "Yes, cancel"
                }
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Submit" : "No, continue"}
              />
            </div>
          )}
        </ModalComponent>
      )}
      {alertType.msg && (
        <TransitionAlerts isAlert={alert} message={alertType.msg} />
      )}
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default BtnSet;
